import { Person } from "@mapmycustomers/shared/types/entity";

// Resolves the array the picker should show. Used both for initial mount and
// for re-syncing when the upstream associatedPeople list changes (e.g. parent
// re-fetches an activity), so it must preserve the user's in-progress edits
// in multiselect mode rather than blindly overwriting them.
const resolveSelectedPeople = (
  multiselect: boolean,
  associatedPeople: Person[] | undefined,
  current: Person[] = []
): Person[] => {
  if (multiselect && current.length) {
    return current;
  }
  return associatedPeople ?? [];
};

export default resolveSelectedPeople;
